import React from 'react';

export default function Square(): JSX.Element {
  return <div style={{ height: '100px', width: '100px', backgroundColor: '#606060' }}></div>;
}
